import React from 'react';
import { DossierEnAttenteView } from './components/DossierEnAttenteView';

export const DossierEnAttenteTab: React.FC = () => {
  return <DossierEnAttenteView />;
};